import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      common: {
        ...store.getState().i18n.translations.en.common,
        popup: {
          ...store.getState().i18n.translations.en.common.popup,
          popupBuyReport: {
            TITLE: 'Explore more features',
            DESC: `Download FiinGate Factsheet now to experience this feature.`,
            NOT_NOW: 'Not now',
            DOWNLOAD_FF: 'Download FiinGate Factsheet',
          },
        },
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      common: {
        ...store.getState().i18n.translations.vi.common,
        popup: {
          ...store.getState().i18n.translations.vi.common.popup,
          popupBuyReport: {
            TITLE: 'Khám phá thêm tính năng',
            DESC: `Vui lòng tải FiinGate Factsheet để trải nghiệm chức năng này.`,
            NOT_NOW: 'Để lúc khác',
            DOWNLOAD_FF: 'Tải FiinGate Factsheet',
          },
        },
      },
    },
  }),
)
